module.exports = __webpack_public_path__ + "static/media/Events.9fd6270a.less";